/**
 * Application configuration
 */

export const CHART_COLOR = ['#85B98E', '#4F8BD1', '#D93E25', '#60aff4', '#0033cc'];
export const CHART_COLOR_2 = ['#85B98E', '#4F8BD1', '#60aff4'];
export const CHART_COLOR_3 = ['#70ad48', '#e2f0d9', '#ed7d31', '#ffc82b', '#000000'];
export const CHART_COLOR_3b = ['#70ad48', '#e2f0d9', '#000000'];
export const CHART_COLOR_NEW = ['#4F8BD1', '#85B98E', '#D93E25', '#60aff4', '#0033cc', '#E7F1E8'];
export const DARKEN_CHART_COLOR = ['#4F8BD1', '#85B98E', '#D93E25', '#0a599f'];
export const CHART_FONTSIZE = 11;

export const CHART_BARCHART_OPTIONS = {
  legend: { position: 'top', maxLines: 3 },
  bar: { groupWidth: '75%' },
  isStacked: true,
  backgroundColor: { fill: 'transparent' },
  colors: CHART_COLOR,
  fontSize: CHART_FONTSIZE,
  chartArea: { 'width': '70%', 'height': '75%' },
  animation: {
    duration: 1000,
    easing: 'out',
    startup: true
  },
  annotations: {
    alwaysOutside: true,
    datum: {
      stem: {
        color: '',
        length: 5,
      }
    },
    // boxStyle: {
    //   // Color of the box outline.
    //   stroke: '#F26F5F',
    //   // Thickness of the box outline.
    //   strokeWidth: 5,
    //   // x-radius of the corner curvature.
    //   rx: 10,
    //   // y-radius of the corner curvature.
    //   ry: 10,
    //   // Attributes for linear gradient fill.
    //   gradient: {
    //     // Start color for gradient.
    //     color1: '#F26F5F',
    //     // Finish color for gradient.
    //     color2: '#F26F5F',
    //     // Where on the boundary to start and
    //     // end the color1/color2 gradient,
    //     // relative to the upper left corner
    //     // of the boundary.
    //     x1: '0%', y1: '0%',
    //     x2: '100%', y2: '100%',
    //     // If true, the boundary for x1,
    //     // y1, x2, and y2 is the box. If
    //     // false, it's the entire chart.
    //     //useObjectBoundingBoxUnits: true
    //   }
    // },
    textStyle: {
      bold: true,
      italic: false,
      fontSize: 15,
      // The color of the text.
      color: '#000000',
      // The color of the text outline.
      auraColor: '#ffffff',

    }
  }
};

export const CHART_PIECHART_OPTIONS = {
  backgroundColor: { fill: 'transparent' },
  pieHole: 0.6,
  colors: CHART_COLOR,
  fontSize: CHART_FONTSIZE,
  legend: {
    position: 'labeled',
    labeledValueText: 'both',
    alignment: 'start',
    textStyle: {
      color: 'black',
      fontSize: 15
    }
  },
  chartArea: { 'width': '100%', 'height': '75%' },
  //height: 150,
  //width: "50%",
  animation: {
    duration: 4000,
    easing: 'out',
    startup: true
  },
  //pieSliceText: 'value',
  pieSliceText: 'none',
  sliceVisibilityThreshold: 0,
  pieSliceTextStyle: {
    color: 'black',
  },
};

export const CHART_LINECHART_OPTIONS = {
  legend: {
    position: 'none',
    maxLines: 3,
    textStyle: { fontSize: 10 }
  },
  backgroundColor: { fill: 'transparent' },
  colors: CHART_COLOR_NEW,
  fontSize: CHART_FONTSIZE,
  chartArea: { 'width': '85%', 'height': '75%' },
  animation: {
    duration: 1000,
    easing: 'out',
    startup: true
  },
  annotations: {
    textStyle: {
      color: '#ffffff',
      fontSize: 15,
    },
    boxStyle: {
      // Color of the box outline.
      stroke: '#F26F5F',
      // Thickness of the box outline.
      strokeWidth: 5,
      // x-radius of the corner curvature.
      rx: 10,
      // y-radius of the corner curvature.
      ry: 10,
      // Attributes for linear gradient fill.
      gradient: {
        // Start color for gradient.
        color1: '#F26F5F',
        // Finish color for gradient.
        color2: '#F26F5F',
        // Where on the boundary to start and
        // end the color1/color2 gradient,
        // relative to the upper left corner
        // of the boundary.
        x1: '0%', y1: '0%',
        x2: '100%', y2: '100%',
        // If true, the boundary for x1,
        // y1, x2, and y2 is the box. If
        // false, it's the entire chart.
        //useObjectBoundingBoxUnits: true
      }
    }
  },
};

export const DEFAULT_ROUTE = "/";

// Breadcrumb item configuration
const BREADCRUMB_ITEMS = [
  {
    id: "home",
    params: "heat",
    index: 0,
    label: 'BREADCRUMB_HOME',
    label_new: "STATUS_HABITATION",
  },
  {
    id: "hpchoice",
    index: 1,
    label: 'BREADCRUMB_HP_CHOICE',
    label_new: "STATUS_HP_CHOICE",
  },
  {
    id: "results",
    index: 2,
    label: 'BREADCRUMB_RESULTS',
    label_new: "STATUS_RESULTS",
  },
  {
    id: "acc",
    index: 3,
    label: 'BREADCRUMB_ACCESSORIES',
    label_new: "STATUS_ACCESSORIES",
  },
  // {
  //   id: "quote",
  //   index: 4,
  //   label: 'BREADCRUMB_QUOTE'
  // },
  {
    id: "synthesis",
    index: 4,
    label: 'BREADCRUMB_DOC_QUOTE',
    label_new: "COMPLETED",
  },
  // {
  //   id: "synthesis",
  //   index: 5,
  //   label: 'BREADCRUMB_SYNTHESIS'
  // },
];
export const getBreadcrumbItems = (disabledSteps: any) => {
  if (!disabledSteps) return BREADCRUMB_ITEMS

  try {
    const disabledStepsArray = disabledSteps.split(',')
    return BREADCRUMB_ITEMS.filter(i => !disabledStepsArray.find((ds: any) => ds === i.id))
  } catch (ex) {
    return BREADCRUMB_ITEMS
  }
}

const SYNTHESIS_PAGES = [
  {
    id: "200",
    label: "SYNTH_QUOTE",//"Étude",
    pageId: '1'
  },
  {
    id: "300_400_500_600",
    label: "SYNTH_BARTH",//"Devis",
    pageId: '2'
  },
  {
    id: "700_800_900_1000",
    label: "SYNTH_HOUSE_DATA",//"Schéma hydraulique",
    pageId: '3'
  },
  // {
  //   id: "1000",
  //   // label: "SYNTH_PAC",//"Estimatif des consommations",
  //   label: "CONSUMPTION_ESTIMATE_COLDMODE",//"Estimatif des consommations Froid",
  //   pageId: "3"
  // },
  {
    id: "1100",
    label: "SYNTH_PAC",//"Estimatif des consommations",
    pageId: "4"
  },
  {
    id: "1200",
    label: "SYNTH_ACC", //"Informations accessoires",
    pageId: "5"
  },
  {
    id: "1300",
    label: "SYNTH_TECHNICAL_DATA",//"Comparatif des énergies",
    pageId: "6"
  },
  {
    id: "1400",
    label: "SYNTH_COMPARISON",//"Avantages fiscaux et aides",
    pageId: "7"
  },
  {
    id: "1500",
    label: "SYNTH_CONSUMPTION",//"Avantages fiscaux et aides",
    pageId: "8"
  },
  {
    id: "1600",
    label: "SYNTH_HYDRAU",//"Avantages fiscaux et aides",
    pageId: "9"
  },
  {
    id: "1700",
    label: "SYNTH_ELEC",//"Avantages fiscaux et aides",
    pageId: "10"
  },
  {
    id: "1900",
    label: "SYNTH_ANNEX",//"Résumé",
    pageId: "13"
  }
];
export const getSynthesisPages = (SYNTH_PARAMETER: any) => {
  if (!SYNTH_PARAMETER) return SYNTHESIS_PAGES

  try {
    const synthParameterArray = String(SYNTH_PARAMETER)
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean)

    return SYNTHESIS_PAGES.filter((page) => synthParameterArray.includes(page.pageId))
  } catch (ex) {
    return SYNTHESIS_PAGES
  }
}